import accounting from 'accounting';

// Format value to money format according to 'accounting'
// accounting.formatMoney is not always accurate e.g. 1.005 becomes "1,00", this fixes that.
export const formatMoney = (value: string | number, decimals = 0) =>
	accounting.formatMoney(value, '', decimals, ' ', ',');
